"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralShipmentInformationBXToJSON = exports.GeneralShipmentInformationBXFromJSONTyped = exports.GeneralShipmentInformationBXFromJSON = exports.instanceOfGeneralShipmentInformationBX = void 0;
/**
 * Check if a given object implements the GeneralShipmentInformationBX interface.
 */
function instanceOfGeneralShipmentInformationBX(value) {
    return true;
}
exports.instanceOfGeneralShipmentInformationBX = instanceOfGeneralShipmentInformationBX;
function GeneralShipmentInformationBXFromJSON(json) {
    return GeneralShipmentInformationBXFromJSONTyped(json, false);
}
exports.GeneralShipmentInformationBXFromJSON = GeneralShipmentInformationBXFromJSON;
function GeneralShipmentInformationBXFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'transaction_set_purpose_code_01': json['transaction_set_purpose_code_01'] == null ? undefined : json['transaction_set_purpose_code_01'],
        'transportation_method_type_code_02': json['transportation_method_type_code_02'] == null ? undefined : json['transportation_method_type_code_02'],
        'shipment_method_of_payment_code_03': json['shipment_method_of_payment_code_03'] == null ? undefined : json['shipment_method_of_payment_code_03'],
        'shipment_identification_number_04': json['shipment_identification_number_04'] == null ? undefined : json['shipment_identification_number_04'],
        'standard_carrier_alpha_code_05': json['standard_carrier_alpha_code_05'] == null ? undefined : json['standard_carrier_alpha_code_05'],
        'weight_unit_code_06': json['weight_unit_code_06'] == null ? undefined : json['weight_unit_code_06'],
        'shipment_qualifier_07': json['shipment_qualifier_07'] == null ? undefined : json['shipment_qualifier_07'],
        'section_seven_code_08': json['section_seven_code_08'] == null ? undefined : json['section_seven_code_08'],
        'capacity_load_code_09': json['capacity_load_code_09'] == null ? undefined : json['capacity_load_code_09'],
        'status_report_request_code_10': json['status_report_request_code_10'] == null ? undefined : json['status_report_request_code_10'],
        'customs_documentation_handling_code_11': json['customs_documentation_handling_code_11'] == null ? undefined : json['customs_documentation_handling_code_11'],
        'confidential_billing_request_code_12': json['confidential_billing_request_code_12'] == null ? undefined : json['confidential_billing_request_code_12'],
        'goods_and_services_tax_reason_code_13': json['goods_and_services_tax_reason_code_13'] == null ? undefined : json['goods_and_services_tax_reason_code_13'],
        'application_type_code_14': json['application_type_code_14'] == null ? undefined : json['application_type_code_14'],
    };
}
exports.GeneralShipmentInformationBXFromJSONTyped = GeneralShipmentInformationBXFromJSONTyped;
function GeneralShipmentInformationBXToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'transaction_set_purpose_code_01': value['transaction_set_purpose_code_01'],
        'transportation_method_type_code_02': value['transportation_method_type_code_02'],
        'shipment_method_of_payment_code_03': value['shipment_method_of_payment_code_03'],
        'shipment_identification_number_04': value['shipment_identification_number_04'],
        'standard_carrier_alpha_code_05': value['standard_carrier_alpha_code_05'],
        'weight_unit_code_06': value['weight_unit_code_06'],
        'shipment_qualifier_07': value['shipment_qualifier_07'],
        'section_seven_code_08': value['section_seven_code_08'],
        'capacity_load_code_09': value['capacity_load_code_09'],
        'status_report_request_code_10': value['status_report_request_code_10'],
        'customs_documentation_handling_code_11': value['customs_documentation_handling_code_11'],
        'confidential_billing_request_code_12': value['confidential_billing_request_code_12'],
        'goods_and_services_tax_reason_code_13': value['goods_and_services_tax_reason_code_13'],
        'application_type_code_14': value['application_type_code_14'],
    };
}
exports.GeneralShipmentInformationBXToJSON = GeneralShipmentInformationBXToJSON;
